<template>
  <section class="pa-page-title-bar" :class="additionalClass">
    <p>{{pageTitle}}</p>
  </section>
</template>

<script>
export default {
  name  : 'PAPageTitleBar',
  data(){
    return {
      isMinify          : false,
      
      contentOffsetTop  : 5,

      additionalClass   : {
        'pa-page-title-bar-minify'  : false
      }
    };
  },
  watch : {
    isMinify : {
      handler(value){
        this.additionalClass['pa-page-title-bar-minify'] = value;
      },
      immediate: true
    },
  },
  computed : {
    pageTitle(){
      return this.$store.state.pageTitle;
    }
  },
  methods : {
    initializeEvent(){
      window.removeEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.handleScroll);
    },

    handleScroll(){
      if( this.contentOffsetTop <= window.scrollY ){
        this.isMinify = true;
      }else if(window.scrollY < 0){
        this.isMinify = true;
      }else{
        this.isMinify = false;
      }
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.initializeEvent();
    });
  }
}
</script>

<style lang="scss">
.pa-page-title-bar{
  font-size:1.3rem;
  text-align: center;
  color: #D1D1D1;
  font-weight: bold;
  border-bottom:2px solid #893161;
  padding:.3rem 0 .15rem;
  background-color:rgba(145, 61, 96, .9);
  backdrop-filter: blur(10px);
  transition: font-size 0.2s;
  transition-timing-function: ease-in-out;
  user-select: none;
  
  &-minify{
    font-size:.9rem;
  }
}
</style>